module.exports = __webpack_public_path__ + "img/MEIOS-DE-PAGAMENTO-thumb.ae052702.png";